module.exports = __webpack_public_path__ + "img/fauteuil-17.e0a7ef71.jpg";